export const aboutMission = {
  eyebrow: "Misyonumuz",
  title: "Doğru planlama, doğru tanı",
  quote:
    "Radyoloji artık tedavi planlamasının vazgeçilmez bir parçası. Biz de diş hekimlerinin ve hastaların güvenebileceği, hızlı ve doğru sonuç üreten bir görüntüleme partneri olmak için çalışıyoruz.",
  note:
    "Merkezimiz; modern dijital cihazlar, uzman kadro ve dijital raporlama altyapısıyla İstanbul'un en yoğun diş hekimi trafiğinin merkezinde konumlanır. Amacımız, çekimden rapora kadar geçen süreyi olabildiğince kısaltmak ve tedavi planına giden yolda hiçbir zaman bekleme yaratmamak.",
  pillars: [
    "Doğru tanı, doğru planlama",
    "Aynı gün dijital rapor",
    "Hasta ve hekim odaklı hizmet",
    "ALARA — minimum doz",
    "Şeffaf iletişim, etik çalışma",
  ],
};

export const aboutApproach = [
  {
    icon: "ri-focus-3-line",
    title: "Doğru tanı, doğru planlama",
    text: "Yüksek çözünürlüklü görüntü ve uzman radyoloji değerlendirmesi. Tanıdan tedavi planına geçen süreçte tam netlik.",
  },
  {
    icon: "ri-file-chart-line",
    title: "Aynı gün rapor",
    text: "Çekim biter bitmez raporlama yapılır; diş hekiminin tedavi planına başlamasını bekletmeyiz.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Hasta odaklı hizmet",
    text: "Randevulu çalışma, sıfır bekleme ve hızlı iletişim. Hem hastaya hem hekime zaman kazandıran pratik süreç.",
  },
  {
    icon: "ri-cloud-line",
    title: "Dijital teslim",
    text: "DICOM / JPG / PNG / PDF formatlarında teslim, online erişim ve klinik istem formu desteği. Hekiminize tek tıkla.",
  },
];

export const aboutTechnologyPoints = [
  "Daha düşük radyasyon dozu (ALARA)",
  "Yüksek çözünürlüklü görüntü kalitesi",
  "Anında görüntüleme ve raporlama",
  "DICOM ve dijital formatlarda arşivleme",
  "Online paylaşım ve hekim entegrasyonu",
  "Düzenli kalibrasyon, kalite kontrolü",
];

export const aboutReasons = [
  {
    icon: "ri-map-pin-line",
    title: "Merkezi konum",
    text: "Şişli / Osmanbey; toplu taşıma ve araçla kolay ulaşım. M2 metro Osmanbey durağına 2 dakika yürüme.",
  },
  {
    icon: "ri-award-line",
    title: "Uzman kadro",
    text: "Dental radyoloji deneyimine sahip teknik ekip. Yıllık 25.000+ çekim hacmiyle pratiğe dayalı bilgi.",
  },
  {
    icon: "ri-time-line",
    title: "Hızlı süreç",
    text: "Randevudan sonuca 24 saat içinde teslim. Çekim sonrası rapor hemen hekiminize ulaşır.",
  },
  {
    icon: "ri-shield-star-line",
    title: "Güvenilir partner",
    text: "Yüzlerce diş hekiminin düzenli olarak hastasını yönlendirdiği merkez. Uzun vadeli iş birlikleri.",
  },
  {
    icon: "ri-whatsapp-line",
    title: "WhatsApp hızlı iletişim",
    text: "Randevu, soru ve fiyat — hepsi tek kanaldan. Mesaj atın, aynı gün dönüş yapalım.",
  },
];

export const aboutValues = [
  {
    title: "Şeffaflık",
    text: "Fiyat, süreç ve beklentiler hakkında net bilgi. Sürpriz ek ücret yok.",
  },
  {
    title: "Mesleki etik",
    text: "Hasta mahremiyeti, KVKK uyumu ve kalite standartları. Tüm süreçlerde etik çizgi.",
  },
  {
    title: "Sürekli gelişim",
    text: "Teknoloji ve eğitim yatırımı. Cihaz ve yazılım altyapısı düzenli olarak yenilenir.",
  },
  {
    title: "Erişilebilirlik",
    text: "İstanbul'un her yerinden kolay ulaşım. Türkiye genelinden hasta kabulü.",
  },
];

export const aboutStats = [
  { value: "14+", label: "Yıllık tecrübe" },
  { value: "25.000+", label: "Yıllık çekim" },
  { value: "500+", label: "Anlaşmalı diş hekimi" },
  { value: "Aynı gün", label: "Rapor teslimi" },
];